/**
 * ReportsHarvestInspectionJobState
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { FiCheckCircle, FiMinusCircle, FiClock } from 'react-icons/fi';
import { Popup } from 'semantic-ui-react';

// Selectors
import { makeSelectReportsHarvestInspectionJobState } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    jobState?: ?number;
}

export class ReportsHarvestInspectionTimesheetJobState extends React.PureComponent<Props> {
    render() {
        const { jobState } = this.props;

        if (jobState === 'DONE') {
            return (
                <Popup
                    trigger={
                        <FiCheckCircle
                            size={22}
                            className="text pink"
                            style={{ verticalAlign: 'middle' }}
                        />
                    }
                    content="DONE"
                    inverted
                    basic
                    position="top center"
                />
            );
        }
        if (jobState === 'IN_PROGRESS') {
            return (
                <Popup
                    trigger={
                        <FiClock
                            size={22}
                            className="text green"
                            style={{ verticalAlign: 'middle' }}
                        />
                    }
                    content="IN PROGRESS"
                    inverted
                    basic
                    position="top center"
                />
            );
        }
        if (jobState === 'READY') {
            return (
                <Popup
                    trigger={
                        <FiMinusCircle
                            size={22}
                            className="text grey"
                            style={{ verticalAlign: 'middle' }}
                        />
                    }
                    content="READY TO START"
                    inverted
                    basic
                    position="top center"
                />
            );
        }
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    jobState: (state, props) => {
        const { jobType } = props;
        return makeSelectReportsHarvestInspectionJobState(jobType)(
            state,
            props
        );
    }
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionTimesheetJobState
);
